<template>
    <div class="grid grid__row clearfix" :style="rowStyles">
        <slot></slot>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'grid-row',
  computed: {
    ...mapGetters([
      'gutterUnitSpace',
    ]),
    rowStyles() {
      return {
        marginLeft: `-${this.gutterUnitSpace}px`,
        marginRight: `-${this.gutterUnitSpace}px`,
      };
    },
  },
};
</script>
